import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    "q": "How do estate planning attorneys get clients beyond referrals?",
    "a": "Service-specific SEO pages — revocable trust, irrevocable trust, will, probate, business succession. Prospects search by exact need. Pages that match the need convert. Referrals stay strong but stop being the only source."
  },
  {
    "q": "Is SEO worth it for estate planning?",
    "a": "Yes — search volume is stable and intent is high. One trust client offsets months of SEO investment, and trust clients refer family members for life."
  },
  {
    "q": "How do we compete with LegalZoom and discount services?",
    "a": "Education and credibility. Prospects with real assets don't trust LegalZoom — but they need to be told why. Pages that walk through trust scenarios, tax implications, and probate avoidance convert at premium fees."
  },
  {
    "q": "Do you market probate and litigation specifically?",
    "a": "Yes — probate is its own search ecosystem with high urgency. Dedicated probate pages capture an entirely separate pipeline from estate planning."
  },
  {
    "q": "What about business succession and asset protection?",
    "a": "High-margin niches with low competition. We build out business succession and asset protection pages for firms that handle them."
  }
];

export const Route = createFileRoute("/estate-planning-attorney-marketing-colorado")({
  head: () =>
    industryMarketingHead("Estate Planning Attorney", "estate planning law firm", "estate-planning-attorney-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry={"Estate Planning Attorney"}
      industryLower={"estate planning law firm"}
      slug={"estate-planning-attorney-marketing-colorado"}
      subheadline={"We help Colorado estate planning attorneys build a steady pipeline of will, trust, and probate clients — without depending on referrals alone."}
      painPoints={["You rely entirely on financial advisor and CPA referrals","Your site doesn't explain trusts, wills, or probate in a way clients trust","Discount online services (LegalZoom) eat the bottom of your market"]}
      serviceDescriptions={{
        seo: "Rank for wills, trusts, probate, asset protection, business succession, and every estate matter across every Colorado market.",
        googleMaps: "Own 'estate planning attorney near me' in the Map Pack with credibility and review signals.",
        webDesign: "Service-specific pages — revocable trust, irrevocable trust, will, probate — that explain and convert.",
        ppc: "Profitable Google Ads tuned to high-net-worth trust, asset protection, and business succession searches.",
        geoAi: "Get cited when prospects ask ChatGPT 'best estate planning attorney in Denver' or 'trust lawyer near me'.",
        socialMedia: "Educational content that beats LegalZoom on trust and builds authority with advisors.",
      }}
      testimonial={{"quote":"We added an inbound pipeline that doesn't depend on CPA referrals. The trust and probate pages convert better than I thought possible.","role":"Estate Planning Attorney","city":"Castle Rock"}}
      faqs={FAQS}
      cityHubLinks={[{"to":"/colorado-springs","label":"Estate planning attorney marketing in Colorado Springs","description":"Reach high-net-worth clients across the Pikes Peak region."},{"to":"/denver-digital-marketing","label":"Estate planning attorney marketing in Denver","description":"Compete for Denver's wealth-transfer market."},{"to":"/castle-rock-digital-marketing","label":"Estate planning attorney marketing in Castle Rock","description":"High-net-worth trust and asset protection across Castle Rock and Douglas County."}]}
    />
  ),
});
